import type { CSSProperties, ReactNode } from 'react';

/** Shared input style for modal forms. Mirrors the design system tokens. */
export const inputStyle: CSSProperties = {
  background: 'var(--bg-elev)',
  border: '1px solid var(--line-strong)',
  borderRadius: 'var(--r-md)',
  padding: '10px 12px',
  fontSize: 14,
  color: 'var(--ink)',
  outline: 'none',
  width: '100%',
};

/** Labelled field wrapper with optional inline error message. */
export function Field({ label, children, error }: { label: string; children: ReactNode; error?: string }) {
  return (
    <label style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      <span style={{ fontSize: 11.5, color: 'var(--ink-3)', textTransform: 'uppercase', letterSpacing: '0.08em', fontWeight: 600 }}>
        {label}
      </span>
      {children}
      {error && <span style={{ fontSize: 11, color: 'var(--bad)' }}>{error}</span>}
    </label>
  );
}

/** Inline form-level error banner. */
export function FormError({ message }: { message?: string | null }) {
  if (!message) return null;
  return (
    <div
      style={{
        fontSize: 12.5,
        color: 'var(--bad)',
        background: 'color-mix(in oklab, var(--bad) 10%, var(--bg-elev))',
        border: '1px solid color-mix(in oklab, var(--bad) 25%, transparent)',
        padding: '8px 12px',
        borderRadius: 'var(--r-sm)',
      }}
    >
      {message}
    </div>
  );
}
